module.exports = __webpack_public_path__ + "edbd3378051806839a5faa40e40fcf69.jpg";